import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./project2.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Arc from "./images/ARC.drawio.png";
import App from "./App";

function Project2() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP2">
            <h2 id="Title">Language Translation Application</h2>
            <div id="P2Github">
              <a
                href="https://github.com/AkhilTheBoss/languageTranslation"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
          <h4 className="Heading">Goal</h4>
          <p className="Content">
            The goal is to convert spoken speech into its appropriate
            translation text and vocalizes the translated output.
          </p>
          <h4 className="Heading">Introduction</h4>
          <p className="Content">
            Our app is designed to transform spoken words into written text in a
            language of your choice, while also providing the corresponding
            audio output. The application uses a few AWS services: AWS Amplify,
            API Gateway, AWS S3, DynamoDB, CodeCommit, CloudWatch, Amazon
            Translate, and Polly. It also leverages the capabilities of Docker
            and Kubernetes for containerization and deployment ensuring a
            consistent experience regardless of your mode of interaction.
          </p>
          <h4 className="Heading">Diagram</h4>
          <p className="Content">
            <img src={Arc} alt="AppArc_Copy1" className="Diagram" />
          </p>
          <h4 className="Heading">Components</h4>
          <p className="Content">
            <ul>
              <li>
                <strong>AWS Amplify:</strong>
              </li>
              <li>
                <strong>API Gateway:</strong>
              </li>
              <li>
                <strong>AWS S3:</strong>
              </li>
              <li>
                <strong>DynamoDB:</strong>
              </li>
              <li>
                <strong>CodeCommit:</strong>
              </li>
              <li>
                <strong>CloudWatch:</strong>
              </li>
              <li>
                <strong>Amazon Translate:</strong>
              </li>
              <li>
                <strong>Amazon Polly:</strong>
              </li>
              <li>
                <strong>Docker:</strong>
              </li>
              <li>
                <strong>Kubernetes:</strong>
              </li>
            </ul>
          </p>
          <h4 className="Heading">Key Highlights</h4>
          <p className="Content">
            <ul>
              <li>
                <strong>Multilingual Expertise:</strong> The integration of
                Amazon Translate enables precise and rapid translation between
                numerous languages, empowering users to communicate effortlessly
                across borders.
              </li>
              <li>
                <strong>Natural Voice Output:</strong> Using the help of Amazon
                Polly, our application also provides natural sounding voice
                synthesis, allowing you to listen to translations as they were
                meant to be heard.
              </li>
              <li>
                <strong>Language-Speaker Mapper:</strong> Amazon Polly relies on
                two key pieces of information: the target language for
                translation and the speaker's name in order to generate spoken
                text in the selected language. To facilitate this process,
                DynamoDB helps in the mapping between the user's chosen language
                with the appropriate speaker name for Amazon Polly to produce
                the desired vocalized output.
              </li>
              <li>
                <strong>Data Management:</strong> Data storage relies on AWS S3
                buckets, with spoken content residing in one S3 bucket,
                translated information stored in another, and vocalized output
                data kept in a distinct S3 bucket.
              </li>
              <li>
                <strong>Monitoring and Optimization:</strong> AWS CloudWatch
                keeps a watchful eye on our application's performance, ensuring
                that it operates at its best. With CloudWatch, we can
                continuously optimize the application.
              </li>
            </ul>
          </p>
          <h4 className="Heading">Working</h4>
          <p className="Content">
            The application's front end is built using React JS. To interact
            with the application, users speak into their microphones, and the
            audio is captured and converted into text through the utilization of
            the react-speech-recognition library. The application architecture
            employs API Gateway as a proxy server to establish a connection
            between the front end and our Lambda function, which serves as the
            backend, orchestrating various AWS services. Upon capturing the
            spoken text, it is stored in an S3 bucket, and then the text
            undergoes translation via AWS Translate based on the user's language
            selection. The resulting translated text is relayed back to the
            Lambda function, subsequently being stored in another S3 bucket. We
            use DynamoDB to maintain a mapping between the user's chosen
            language, a corresponding speaker, and the translated text. Amazon
            Polly takes the translated text and converts it into speech. The
            resulting audio is delivered back to the Lambda function and
            deposited into yet another S3 bucket. Finally, both the audio and
            translated text is sent from the Lambda function back to our
            application's front end, where they are displayed on our website.
            Amazon Polly offers support for 24 different languages.
            <p>
              If a user selects a language that is not among the 24 supported by
              Amazon Polly, the website will display: "Sorry, we can only
              provide a translation as text and not speech for this language.
              Apologies".
            </p>
          </p>
          <h4 className="Heading">Scope For Improvement</h4>
          <p className="Content">
            <ul>
              <li>
                Expanded Speech Output Capability: Delivering spoken output for
                additional languages.
              </li>
              <li>
                Feedback Mechanism: Implement a user feedback mechanism so that
                users can request additional language support. This can help you
                prioritize which languages to add in future updates.
              </li>
              <li>
                Language Profiles: Create profiles for each supported language,
                highlighting whether it supports both text and speech or just
                text translation. This can provide users with a clear
                understanding of the available features for each language.
              </li>
              <li>
                Language Profiles: Create profiles for each supported language,
                highlighting whether it supports both text and speech or just
                text translation. This can provide users with a clear
                understanding of the available features for each language.
              </li>
              <li>
                Accessibility: consider introducing an alternative input method,
                allowing users to type text and receive both translated text and
                audio output.
              </li>
            </ul>
          </p>
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project2;
